import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useEffect, useState } from 'react';
import { collection, getDocs, getFirestore, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";
import CustomTooltip from './components';
import dayjs, { Dayjs } from 'dayjs';




export default function CelebritiesOverTime(){
    
    const [celebs, setCelebs] = useState("0");
    const db = getFirestore();


    const [celebsData, setCelebsData] = useState(
        [
            { name: '0', uv: 0, pv: 2400, amt: 2400 },
           
        ]
    );


    useEffect(async () => {
        var totalUser = 0;
        const celebs = collection(db, "celebrities");
        var docs = await getDocs(celebs);
        docs.forEach((doc) => {
            totalUser += 1;
        })
        setCelebs(totalUser);
    }, [])


    return (
        <div className='bg-white/10 flex flex-row'>
            <AreaChart
                className='flex-1'
                width={700}
                height={400}
                data={celebsData}
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip ex="celebs" />} />

                <Area type="monotone" dataKey="uv" stroke="white" fill="orange" />
            </AreaChart>

            <div className='flex-1 bg-white/10 flex flex-col justify-between items-start p-5'>
                <div className='text-3xl flex-col'>
                    <div>
                        New Celebrities Over Time
                    </div>
                    <div className='text-6xl font-bold mt-4'>
                        {celebs}
                    </div>
                </div>
                <div className='flex flex-row gap-3'>
                    <button
                        onClick={async () => {

                            var current = dayjs();
                            var last = current.subtract(7, "day");

                            var dateRanges = new Map();

                            for (let index = 0; index < 8; index++) {
                                var loopDate=current.subtract(index,"day").toDate();
                                var day=loopDate.getDate();
                                var month=loopDate.getMonth()+1;
                                var year=loopDate.getFullYear();
                                var mapDate=`${day}-${month}-${year}`.toString();
                                console.log(mapDate);
                                dateRanges.set(mapDate.toString(), 0);
                            }


                            const q = query(collection(db, "celebrities"), where("createdAt", ">", Timestamp.fromDate(last.toDate())));
                            const querySnapshot = await getDocs(q);
                            querySnapshot.forEach((doc) => {
                                var loopDate=doc.data()["createdAt"].toDate();
                                var day=loopDate.getDate();
                                var month=loopDate.getMonth()+1;
                                var year=loopDate.getFullYear();
                                var mapDate=`${day}-${month}-${year}`.toString();

                                var val = dateRanges.get(mapDate.toString());
                                dateRanges.set(mapDate.toString(), val + 1);
                            });
                            console.log("queried");
                            console.log(dateRanges);

                            var tempData=[];
                            var totalcelebs=0
                            dateRanges.forEach((value,key)=>{
                                tempData.unshift(
                                    { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                                );
                                totalcelebs+=value;
                            })
                            setCelebsData([...tempData]);
                            setCelebs(totalcelebs);

                        }}
                        className='p-2 bg-white text-black font-bold rounded'>1W</button>
                    <button 
                    onClick={async () => {

                        var current = dayjs();
                        var last = current.subtract(1, "month");

                        var dateRanges = new Map();

                        for (let index = 0; index < 30; index++) {
                            var loopDate=current.subtract(index,"day").toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();
                            console.log(mapDate);
                            dateRanges.set(mapDate.toString(), 0);
                        }


                        const q = query(collection(db, "celebrities"), where("createdAt", ">", Timestamp.fromDate(last.toDate())));
                        const querySnapshot = await getDocs(q);
                        querySnapshot.forEach((doc) => {
                            var loopDate=doc.data()["createdAt"].toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();

                            var val = dateRanges.get(mapDate.toString());
                            dateRanges.set(mapDate.toString(), val + 1);
                        });
                        console.log("queried");
                        console.log(dateRanges);

                        var tempData=[];
                        var totalcelebs=0
                        dateRanges.forEach((value,key)=>{
                            tempData.unshift(
                                { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                            );
                            totalcelebs+=value;
                        })
                        setCelebsData([...tempData]);
                        setCelebs(totalcelebs);

                    }}
                    className='p-2 bg-white text-black font-bold rounded'>1M</button>
                    <button
                    onClick={async () => {

                        var current = dayjs();
                        var last = current.subtract(1, "year");

                        var dateRanges = new Map();

                        for (let index = 0; index < 365; index++) {
                            var loopDate=current.subtract(index,"day").toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();
                            console.log(mapDate);
                            dateRanges.set(mapDate.toString(), 0);
                        }


                        const q = query(collection(db, "celebrities"), where("createdAt", ">", Timestamp.fromDate(last.toDate())));
                        const querySnapshot = await getDocs(q);
                        querySnapshot.forEach((doc) => {
                            var loopDate=doc.data()["createdAt"].toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();

                            var val = dateRanges.get(mapDate.toString());
                            dateRanges.set(mapDate.toString(), val + 1);
                        });
                        console.log("queried");
                        console.log(dateRanges);

                        var tempData=[];
                        var totalcelebs=0
                        dateRanges.forEach((value,key)=>{
                            tempData.unshift(
                                { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                            );
                            totalcelebs+=value;
                        })
                        setCelebsData([...tempData]);
                        setCelebs(totalcelebs);

                    }}
                    className='p-2 bg-white text-black font-bold rounded'>1Y</button>
                    <button
                    onClick={async () => {

                        var current = dayjs();
                        var last = current.subtract(1, "year");

                        var dateRanges = new Map();

                        for (let index = 0; index < 365; index++) {
                            var loopDate=current.subtract(index,"day").toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();
                            console.log(mapDate);
                            dateRanges.set(mapDate.toString(), 0);
                        }


                        const q = query(collection(db, "celebrities"), where("createdAt", ">", Timestamp.fromDate(last.toDate())));
                        const querySnapshot = await getDocs(q);
                        querySnapshot.forEach((doc) => {
                            var loopDate=doc.data()["createdAt"].toDate();
                            var day=loopDate.getDate();
                            var month=loopDate.getMonth()+1;
                            var year=loopDate.getFullYear();
                            var mapDate=`${day}-${month}-${year}`.toString();

                            var val = dateRanges.get(mapDate.toString());
                            dateRanges.set(mapDate.toString(), val + 1);
                        });
                        console.log("queried");
                        console.log(dateRanges);

                        var tempData=[];
                        var totalcelebs=0
                        dateRanges.forEach((value,key)=>{
                            tempData.unshift(
                                { name: key.toString(), uv: value, pv: 2400, amt: 2400 },
                            );
                            totalcelebs+=value;
                        })
                        setCelebsData([...tempData]);
                        setCelebs(totalcelebs);

                    }}
                    className='p-2 bg-white text-black font-bold rounded'>All</button>
                </div>
            </div>

        </div>
    )
}